import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { CheckIcon } from './Icons';
export function ServiceIncludesSection() {
  const includes = ['Asesoramiento personalizado para su tipo de evento', 'Elaboración artesanal fresca el día del evento', 'Presentación visual cuidada y lista para servir', 'Variedad de opciones saladas, dulces y mixtas', 'Entregas coordinadas en horario acordado', 'Atención directa antes, durante y después del pedido'];
  return <section className="py-24 bg-linen" data-id="element-292">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-293">
        <FadeIn data-id="element-294">
          <div className="bg-warm-white p-8 md:p-12 rounded-sm shadow-sm border border-sand" data-id="element-295">
            <h2 className="text-3xl font-serif text-deep-brown mb-8 text-center" data-id="element-296">
              Lo que incluye nuestro servicio
            </h2>

            <StaggerContainer className="grid md:grid-cols-2 gap-6" data-id="element-297">
              {includes.map((item, index) => <StaggerItem key={index} data-id="element-298">
                  <div className="flex items-start gap-4" data-id="element-299">
                    <CheckIcon className="w-6 h-6 mt-0.5 flex-shrink-0" data-id="element-300" />
                    <span className="text-deep-brown text-lg" data-id="element-301">{item}</span>
                  </div>
                </StaggerItem>)}
            </StaggerContainer>
          </div>
        </FadeIn>
      </div>
    </section>;
}